import _ from 'lodash';

const shouldClearPassword = (isNew, isUnsaved, changed) => {
    return !isNew && !isUnsaved && !changed;
};

const PASSWORD_REPLACEMENT = 'changeme';

export function fillCredPass(cred, { isUnsaved = false } = {}) {
    if (isUnsaved) return { ...cred };

    const filled = { ...cred };

    if (filled.type === 'SNMP v3') {
        if (filled.protocol !== 'None') {
            filled.password = PASSWORD_REPLACEMENT;
        } else {
            filled.password = '';
        }
        if (filled.privacyProtocol !== 'None') {
            filled.privacyPassword = PASSWORD_REPLACEMENT;
        } else {
            filled.privacyPassword = null;
        }
    } else {
        filled.password = PASSWORD_REPLACEMENT;
        filled.privacyPassword = null;
    }

    return filled;
}

function formatSnmpv3(cred, { isNew, isUnsaved, dirtyFields }) {
    if (cred.protocol === 'None') {
        cred.password = null;
        cred.privacyProtocol = 'None';
        cred.privacyPassword = null;
    } else if (cred.privacyProtocol === 'None') {
        cred.privacyPassword = null;
    }

    if (shouldClearPassword(isNew, isUnsaved, !!dirtyFields.password)) {
        cred.password = null;
    }

    if (shouldClearPassword(isNew, isUnsaved, !!dirtyFields.privacyPassword)) {
        cred.privacyPassword = null;
    }
}

function formatSnmpv2c(cred, { isNew, isUnsaved, dirtyFields }) {
    if (shouldClearPassword(isNew, isUnsaved, !!dirtyFields.password)) {
        cred.password = null;
    }

    cred.userName = '';
    cred.context = '';
    cred.protocol = 'None';
    cred.privacyProtocol = 'None';
    cred.privacyPassword = null;
}
function formatWinrm(cred, { isNew, isUnsaved, dirtyFields }) {
    if (shouldClearPassword(isNew, isUnsaved, !!dirtyFields.password)) {
        cred.password = null;
    }

    cred.context = '';
    cred.protocol = 'None';
    cred.privacyProtocol = 'None';
    cred.privacyPassword = null;
}

function formatWinrmCert(cred) {
    cred.userName = '';
    cred.password = null;
    cred.context = '';
    cred.protocol = 'None';
    cred.privacyProtocol = 'None';
    cred.privacyPassword = null;
}

function formatRest(cred, { isNew, isUnsaved, dirtyFields }) {
    if (shouldClearPassword(isNew, isUnsaved, !!dirtyFields.password)) {
        cred.password = null;
    }

    cred.context = '';
    cred.protocol = 'None';
    cred.privacyProtocol = 'None';
    cred.privacyPassword = null;
    cred.subType = 'RuckusVSZ';
}
/**
 * @param {Object} cred
 * @param {Object} options
 * @param {boolean} options.isNew
 * @param {boolean} options.isUnsaved
 * @param {Object} options.dirtyFields
 */
export function formatCredential(cred, options = {}) {
    const { isNew = false, isUnsaved = false, dirtyFields = {} } = options;

    const formatted = _.cloneDeep(cred);

    switch (formatted.type) {
        case 'SNMP v3':
            formatSnmpv3(formatted, { isNew, isUnsaved, dirtyFields });
            break;

        case 'SNMP v2c':
            formatSnmpv2c(formatted, { isNew, isUnsaved, dirtyFields });
            break;

        case 'WinRM':
            formatWinrm(formatted, { isNew, isUnsaved, dirtyFields });
            break;

        case 'WinRM Cert':
            formatWinrmCert(formatted);
            break;

        case 'REST':
            formatRest(formatted, { isNew, isUnsaved, dirtyFields });
            break;

        default:
            break;
    }

    return formatted;
}

export function clearCredPass(cred) {
    if (cred.password === PASSWORD_REPLACEMENT) {
        delete cred.password;
    }

    if (cred.privacyPassword === PASSWORD_REPLACEMENT) {
        delete cred.privacyPassword;
    }

    return cred;
}
